(() => {

  var HelperApp = (() => {
    var getRandomInt = (min, max) => {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const parsePrice = (text) => {
      // extract parts
      const match = text.match(/([^\d\s.,]+)?\s*([\d.,]+)\s*([^\d\s.,]+)?/);
      if (!match) return null;

      const symbol = match[1] || match[3] || "";
      const rawValue = match[2];

      // normalize number
      const normalizeNumber = (value) => {
        const lastDot = value.lastIndexOf(".");
        const lastComma = value.lastIndexOf(",");

        if (lastDot > lastComma) {
          return parseFloat(value.replace(/,/g, ""));
        } else if (lastComma > lastDot) {
          return parseFloat(value.replace(/\./g, "").replace(",", "."));
        } else {
          return parseFloat(value.replace(",", "."));
        }
      };

      return {
        symbol,
        value: normalizeNumber(rawValue),
        raw: rawValue
      };
    };
    const customFormatPrice = (sample, amount) => {
      const { symbol, raw } = parsePrice(sample);

      // detect format
      const isEU = raw.includes(",") && raw.lastIndexOf(",") > raw.lastIndexOf(".");
      const hasThousands = raw.includes(",") || raw.includes(".");
      const decimals = (raw.split(/[.,]/)[1] || "").length;

      let formatted;

      if (isEU) {
        // EU format → 1.017,99
        formatted = amount
          .toFixed(decimals)
          .replace(".", ",")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        // US format → 1,017.99
        formatted = amount
          .toFixed(decimals)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      // symbol position (before or after)
      if (sample.trim().startsWith(symbol)) {
        return `${symbol}${formatted}`;
      } else {
        return `${formatted} ${symbol}`.trim();
      }
    };
    var addNewBlockToKachingBundleSection = () => {
      function waitForBundleSection(callback) {
        // First check if the element already exists
        const existingElement = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');
        if (existingElement) {
          callback(existingElement);
          return;
        }
    
        // If DOM is not ready, wait for it
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            pollForElement(callback);
          });
        } else {
          pollForElement(callback);
        }
      }
    
      function pollForElement(callback) {
        const checkInterval = setInterval(() => {
          const element = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');
          if (element) {
            clearInterval(checkInterval);
            callback(element);
          }
        }, 100); // Check every 100ms
    
        // Stop polling after 30 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          console.warn('Kaching bundle section not found within 30 seconds');
        }, 30000);
      }
    
      // Actually call the function with a callback
      waitForBundleSection((section) => {
        if (document.querySelector('[js-kaching-bundle-info]')) {
          const titleElement = section.querySelector('.kaching-bundles__block-title');
          
          const textBlock = document.querySelector('[js-kaching-bundle-info]').innerHTML;
          
          if (titleElement) {
            titleElement.insertAdjacentHTML('afterend', textBlock);
            let band_size_flag = false;
            let cup_size_flag = false;
            section.querySelectorAll('.kaching-bundles__bar-variant-selects .kaching-bundles__bar-variant-select').forEach(select => {
              select.addEventListener('change', (event) => {
                if (select.getAttribute('data-name') !== 'Band Size' && select.getAttribute('data-name') !== 'Cup Size') {
                  return;
                }
                if (select.getAttribute('data-name') === 'Band Size') {
                  band_size_flag = true;
                }
                if (select.getAttribute('data-name') === 'Cup Size') {
                  cup_size_flag = true;
                }
                if (band_size_flag && cup_size_flag) {
                  section.querySelectorAll('.kaching-bundles__block .kaching-bundle-info--wrapper').forEach(bundleInfoWrapper => {
                    const infoText = bundleInfoWrapper.querySelector('[js-kaching-bundle-info-text]');
                    var randomValue = HelperApp.getRandomInt(96, 98);
                    var selected_size = '';
                    select.closest('.kaching-bundles__bar-variant-selector-wrapper').querySelectorAll('.kaching-bundles__bar-variant-select').forEach(subselect => {
                      if (subselect.getAttribute('data-name') === 'Band Size') {
                        selected_size += subselect.value;
                      }
                      if (subselect.getAttribute('data-name') === 'Cup Size') {
                        selected_size += subselect.value;
                      }
                    });
                    if (infoText) {
                      infoText.innerHTML = infoText.getAttribute('js-kaching-bundle-info-text').replace('((random_value))', String(randomValue)).replace('((selected_size))', selected_size);
                    }
                    bundleInfoWrapper.classList.remove('d-none');
                  });
                }
              });
            });
          }
        }
        if (!document.body.classList.contains('page-shapping-c-vibe-3-0')) return;
        if (section.querySelector('.bundle--shipping-text')) {
          console.log('Shipping text already exists, skipping...');
          return;
        }
        
        // Find the title element
        const titleElement = section.querySelector('.kaching-bundles__block-title');
        
        const textBlock = `
          <div class="bundle--shipping-text">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <g clip-path="url(#clip0_1051_9097)">
                  <path d="M8.49992 14.7913C12.1818 14.7913 15.1666 11.8066 15.1666 8.12467C15.1666 4.44278 12.1818 1.45801 8.49992 1.45801C4.81802 1.45801 1.83325 4.44278 1.83325 8.12467C1.83325 11.8066 4.81802 14.7913 8.49992 14.7913Z" stroke="#007A4D" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.5 8.12533L7.83333 9.45866L10.5 6.79199" stroke="#007A4D" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_1051_9097">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.125)"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="text">Incl. free shipping to the US & worldwide</span>
          </div>
        `;
        
        if (titleElement) {
          // Insert your HTML content right after the title element
          titleElement.insertAdjacentHTML('afterend', textBlock);
          console.log('Shipping text added after title element');
        } else {
          console.warn('kaching-bundles__block-title not found, appending to end');
          // Fallback: add to the end of the section
          section.insertAdjacentHTML('beforeend', textBlock);
          console.log('Shipping text added to end of section');
        }
      });
    };

    var addSizeGuideToBundle = () => {
      function addSizeGuideToSelected() {
  const selectedBar = document.querySelector(
    '.kaching-bundles__bar--selected .kaching-bundles__bar-wrapper'
  );

  const isABTestTemplate = document.body.classList.contains(
    'page-sh-19-abtesting-redesign'
  );

  let sizeGuide;
  let removeSelector;

  if (isABTestTemplate) {
    sizeGuide = document.querySelector('.product-info__kaching-bundle-info');
    removeSelector =
      '.kaching-bundles__bar .product-info__kaching-bundle-info';
  } else {
    sizeGuide = document.querySelector('[data-block-type="size-guide"]');
    removeSelector =
      '.kaching-bundles__bar [data-block-type="size-guide"]';
  }

  document.querySelectorAll(removeSelector).forEach((guide) => {
    guide.remove();
  });

  if (selectedBar && sizeGuide) {
    const sizeGuideClone = sizeGuide.cloneNode(true);
    sizeGuideClone.style.display = 'block';
    selectedBar.appendChild(sizeGuideClone);
  }
}

      function observeBundleChanges() {
        const bundleContainer = document.querySelector('.kaching-bundles') || document.body;
        
        const observer = new MutationObserver(() => {
          addSizeGuideToSelected();
        });

        observer.observe(bundleContainer, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });

        // Initial check
        addSizeGuideToSelected();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeBundleChanges);
      } else {
        observeBundleChanges();
      }
    };

    var addItemToCart = async (variant_id, quantity = 1) => {
      const formData = new URLSearchParams();
      formData.append('id', variant_id);
      formData.append('quantity', quantity);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));
          // document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
          //   bubbles: true,
          //   detail: {
          //     items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          //     cart: cartContent
          //   }
          // }));
  
          // document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          //   bubbles: true,
          //   detail: {
          //     baseEvent: "variant:add",
          //     cart: cartContent
          //   }
          // }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };

    var updateLineItemKeys = async () => {
      // try {
      //   const response = await fetch('/cart.js');
      //   const cart = await response.json();
        
      //   document.querySelectorAll('line-item').forEach(lineItem => {
      //     const lineIndex = parseInt(lineItem.dataset.lineIndex);
      //     const cartItem = cart.items[lineIndex];
          
      //     if (cartItem && cartItem.key !== lineItem.dataset.lineKey) {
      //       console.log(`Updating key at index ${lineIndex}:`, lineItem.dataset.lineKey, '->', cartItem.key);
      //       lineItem.dataset.lineKey = cartItem.key;
      //       lineItem.querySelectorAll('[data-line-key]').forEach(subelement => {
      //         subelement.dataset.lineKey = cartItem.key;
      //       });
      //     }
      //   });
      // } catch (error) {
      //   console.error('Cart sync error:', error);
      // }
    }

    var addPricePerUnitToKachingBundlePicker = () => {
      function addBlock() {
        if (!document.body.hasAttribute('sh-off-2-ab-test')) return;
        document.querySelectorAll('.kaching-bundles__bar-pricing:has(.kaching-bundles__bar-price):not(:has(.price__full-price))').forEach(container => {
          const {symbol, value, raw} = parsePrice(container.querySelector('.kaching-bundles__bar-price').innerText);
          const bundleBarWrapper = container.closest('.kaching-bundles__bar');
          if (!bundleBarWrapper) return;
          const count = bundleBarWrapper.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').length;
          if (count > 0) {
            container.innerHTML = `
              <div class="unit-price">
                <span class="value">${customFormatPrice(container.querySelector('.kaching-bundles__bar-price').innerText, Math.floor(value * 100 / count) / 100)}</span>
                <span class="label">${container.closest('[data-bundle-picker-unit-price-label]') ? container.closest('[data-bundle-picker-unit-price-label]').getAttribute('data-bundle-picker-unit-price-label') : ''}</span>
              </div>
              <div class="price__full-price">${container.innerHTML}</div>
            `;
          }
        });
      }

      function observeBundleChanges() {
        const bundleContainer = document.querySelector('.kaching-bundles') || document.body;
        
        const observer = new MutationObserver(() => {
          addBlock();
        });

        observer.observe(bundleContainer, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });

        // Initial check
        addBlock();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeBundleChanges);
      } else {
        observeBundleChanges();
      }
    };

    return {
      addItemToCart: addItemToCart,
      addSizeGuideToBundle: addSizeGuideToBundle,
      addNewBlockToKachingBundleSection: addNewBlockToKachingBundleSection,
      getRandomInt: getRandomInt,
      updateLineItemKeys: updateLineItemKeys,
      addPricePerUnitToKachingBundlePicker: addPricePerUnitToKachingBundlePicker
    };
  })();
  

  var PDPSizeFinderApp = (() => {
    var selectBlock = (element) => {
      if (!element || !element.closest('product-gallery')) return;
      const container = element.closest('product-gallery');
      let index = 0;
      element.querySelectorAll('.product-gallery__media').forEach((media, i) => {
        if (media.classList.contains('is-selected')) {
          index = i;
        }
      });
      container.querySelectorAll(`[js-pdp-size-finder-wrapper] [data-index]`).forEach(block => {
        if (block.classList.contains('active')) {
          block.classList.remove('active');
        }
        if (block.getAttribute('data-index') === String(index)) {
          block.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('product-gallery media-carousel').forEach(carousel => {
        carousel.addEventListener('scrollend', (e) => {
          selectBlock(carousel);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var ShippingProtectApp = (() => {
    let shippingProtectLineId = null;
    var addShippingProtect = async (variant_id, element) => {
      if (!element) return;
      element.classList.add('loading');
      element.classList.add('active');
      const formData = new URLSearchParams();
      formData.append('id', variant_id);
      formData.append('quantity', 1);
      formData.append('properties[_is_shipping_protect]', true);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };
    var removeShippingProduct = async (element) => {
      if (!shippingProtectLineId) return;
      if (!element) return;
      element.classList.add('loading');
      element.classList.remove('active');
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: shippingProtectLineId,
          quantity: 0
        })
      })).json();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    var checkAddedShippingProduct = async (variant_id) => {
      let flag = false;
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.items.forEach(item => {
        if (String(item.id) === String(variant_id)) {
          flag = true;
          shippingProtectLineId = item.key;
        }
      });
      return flag;
    }
    var trigger = async (element) => {
      if (!element) return;
      if (element.classList.contains('loading')) return;
      const flag = await checkAddedShippingProduct(element.getAttribute('data-variant-id'));
      if (!flag) {
        addShippingProtect(element.getAttribute('data-variant-id'), element);
      } else {
        removeShippingProduct(element);
      }
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.hasAttribute('js-shipping-protect-trigger')) {
          element = event.target;
        }
        if (event.target.closest('[js-shipping-protect-trigger]')) {
          element = event.target.closest('[js-shipping-protect-trigger]');
        }
        if (element) {
          trigger(element);
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var CartTimerApp = (() => {
    const TIMER_KEY = "reservation_timer_end";
    const RESERVATION_DURATION_MINUTES = 10;
  
    var runCountdown = () => {
      setInterval(() => {
        let endTime = localStorage.getItem(TIMER_KEY);
  
        if (!endTime) {
          return;
        }

        endTime = parseInt(endTime, 10);

        const timerElement = document.querySelector("[js-cart-drawer-timer]");
        if (!timerElement) return;
        const now = Date.now();
        const remaining = endTime - now;
  
        if (remaining <= 0) {
          timerElement.style.display = 'none';
          localStorage.removeItem(TIMER_KEY);
          return;
        }

        timerElement.style.display = 'flex';
  
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
  
        if (timerElement.querySelector('[data-template]')) {
          timerElement.querySelector('[data-template]').innerText = String(timerElement.querySelector('[data-template]').getAttribute('data-template')).replace('((value))', `${pad(minutes)}:${pad(seconds)}`);
        }
      }, 3);
    }
  
    var pad = (n) => {
      return n < 10 ? '0' + n : n;
    }

    var initialize = () => {
      let endTime = localStorage.getItem(TIMER_KEY);

      if (!endTime) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + RESERVATION_DURATION_MINUTES);
        endTime = now.getTime();
        localStorage.setItem(TIMER_KEY, endTime);
      }

      runCountdown();
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellProductApp = (() => {
    function arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }

    var addUpsellProduct = async (container) => {
      if (!container || !container.querySelector('script')) return;
      const productInfo = JSON.parse(container.querySelector('script').innerHTML);
      if (!productInfo.variants) return;
      const valueList = [];
      container.querySelectorAll('.variant-option').forEach(element => {
        if (element.querySelector('.active[data-value]')) {
          valueList.push(element.querySelector('.active[data-value]').getAttribute('data-value'))
        } else if (element.querySelector('select')) {
          valueList.push(element.querySelector('select').value);
        }
      });
      let variantId = null;
      productInfo.variants.forEach(variant => {
        if (arraysEqual(variant.options, valueList)) {
          variantId = variant.id;
        }
      });
      if (variantId === null) return;
      container.classList.add('loading');
      const formData = new URLSearchParams();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('properties[_upsell_added]', "true");
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));

          container.classList.add('success');
          container.classList.remove('loading');
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
    var colorChanged = (element, container) => {
      if (!element || !element.closest('.variant-color-option') || !container) return;
      element.closest('.variant-color-option').querySelectorAll('[data-value]').forEach(valueElement => {
        valueElement.classList.remove('active');
      });
      element.classList.add('active');
      const variantId = element.getAttribute('data-variant-id');
      if (variantId !== '') {
        container.querySelectorAll('.image-wrapper img').forEach(image => {
          if (image.getAttribute('data-variant-id') === variantId) {
            image.classList.add('active');
          } else {
            image.classList.remove('active');
          }
        });
      }
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.closest('[js-cart-drawer-upsell-atc]')) {
          element = event.target.closest('[js-cart-drawer-upsell-atc]');
        }
        if (element && element.closest('[js-container]') && !element.closest('[js-container]').classList.contains('loading')) {
          addUpsellProduct(element.closest('[js-container]'));
        }
        if (event.target.closest('[data-value]') && event.target.closest('.variant-color-option')) {
          element = event.target.closest('[data-value]');
          colorChanged(element, element.closest('[js-container]'));
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var TabsContainerApp = (() => {
    var open = (container, index) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        element.classList.remove('active');
        if (element.getAttribute('data-index') === index) {
          element.classList.add('active');
        }
      });
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(container, element.getAttribute('data-index'));
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tabs-container]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();


  var PDPBundlePickerApp = (() => {
    var addBundleToCart = async (container) => {
      if (!container) return;
      
      const current_bundle_option_index = parseInt(container.getAttribute('data-selected-bundle-option'));
      let variant_id_list = [];
      
      // Collect variant IDs based on selected bundle option
      container.querySelectorAll('[js-bundle-variant-picker][data-variant-id]').forEach((element, index) => {
        if (index < current_bundle_option_index) {
          variant_id_list.push(element.getAttribute('data-variant-id'));
        }
      });
    
      if (variant_id_list.length === 0) {
        console.warn('No variants selected for bundle');
        return;
      }
    
      // Disable submit buttons during processing
      const submitButtons = container.querySelectorAll('[js-submit]');
      submitButtons.forEach((button) => {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-busy', 'true');
      });
    
      try {
        // Prepare sections to bundle (similar to theme.js product form logic)
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { 
          bubbles: true, 
          detail: { sections: sectionsToBundle } 
        }));
    
        // Prepare items for bulk add to cart
        const items = variant_id_list.map(variant_id => ({
          id: variant_id,
          quantity: 1
        }));
    
        // Prepare the request body
        const requestBody = {
          items: items
        };
    
        // Add sections if available
        if (sectionsToBundle.length > 0) {
          requestBody.sections = sectionsToBundle.join(',');
          requestBody.sections_url = `${Shopify.routes.root}variants/${variant_id_list[0]}`;
        }
    
        // Add all variants to cart at once
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(requestBody)
        });
    
        if (!response.ok) {
          const errorJson = await response.json();
          throw new Error(errorJson.description || 'Failed to add bundle to cart');
        }
    
        const responseJson = await response.json();
        
        // Get updated cart content
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        
        // Add sections from response if available
        if (responseJson.sections) {
          cartContent["sections"] = responseJson["sections"];
        }
    
        // Dispatch variant:add event (similar to theme.js)
        container.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson], // Handle both single and multiple item responses
            cart: cartContent,
            blockCartDrawerOpening: false // Allow cart drawer to open
          }
        }));
    
        // Dispatch cart:change event (similar to theme.js)
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
    
      } catch (error) {
        console.error("Bundle add to cart failed:", error);
    
        // Dispatch error event
        container.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Failed to add bundle to cart"
          }
        }));
    
        // Refresh cart on error
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        
      } finally {
        // Re-enable submit buttons
        submitButtons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
        });
      }
    }
    
    var selectBundleOption = (container, option_index) => {
      if (!container) return;
      container.setAttribute('data-selected-bundle-option', option_index);
      container.querySelectorAll('[data-bundle-option]').forEach(element => {
        if (element.getAttribute('data-bundle-option') === option_index) element.classList.add('active');
        else element.classList.remove('active');
      });
      
      // Force reinitialize all variant pickers with different default colors
      // Use requestAnimationFrame to ensure DOM updates are complete
      requestAnimationFrame(() => {
        container.querySelectorAll('[js-bundle-variant-picker]').forEach(element => {
          BundleVariantPickerApp.initializeDefaultVariant(element);
        });
      });
    }
    
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[data-bundle-option]').forEach(element => {
        element.addEventListener('click', () => {
          selectBundleOption(container, element.getAttribute('data-bundle-option'));
        });
      });
      container.querySelectorAll('[js-submit]').forEach(element => {
        element.addEventListener('click', () => {
          addBundleToCart(container);
        });
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-bundle-picker]').forEach(container => {
        initEachContainer(container);
      });
    }
    
    return {
      init: initialize
    }
  })();


  var BundleVariantPickerApp = (() => {
    var productData = {};
    
    var getCurrentOptions = (container) => {
      const options = {};
      container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, index) => {
        const selectedOption = wrapper.querySelector('[js-option].selected');
        if (selectedOption) {
          options[`option${index + 1}`] = selectedOption.getAttribute('js-option');
        }
      });
      return options;
    };
  
    var findVariantByOptions = (productId, options) => {
      const product = productData[productId];
      if (!product || !product.variants) return null;
  
      return product.variants.find(variant => {
        return variant.option1 === options.option1 &&
               variant.option2 === options.option2 &&
               variant.option3 === options.option3;
      });
    };
  
    var isOptionAvailable = (productId, optionIndex, optionValue, currentOptions) => {
      const product = productData[productId];
      if (!product || !product.variants) return false;
  
      const testOptions = { ...currentOptions };
      testOptions[`option${optionIndex}`] = optionValue;
  
      return product.variants.some(variant => {
        const matches = Object.keys(testOptions).every(key => {
          const optionNum = key.replace('option', '');
          return variant[`option${optionNum}`] === testOptions[key] || !testOptions[key];
        });
        return matches && variant.available;
      });
    };
  
    var updateOptionAvailability = (container) => {
      const productJson = container.querySelector('script[data-product-json]');
      if (!productJson) return;
  
      try {
        const product = JSON.parse(productJson.textContent);
        const productId = product.id;
        productData[productId] = product;
  
        const currentOptions = getCurrentOptions(container);
  
        container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, wrapperIndex) => {
          const optionIndex = wrapperIndex + 1;
          
          wrapper.querySelectorAll('[js-option]').forEach(optionElement => {
            const optionValue = optionElement.getAttribute('js-option');
            const isAvailable = isOptionAvailable(productId, optionIndex, optionValue, currentOptions);
            
            if (isAvailable) {
              optionElement.classList.remove('disabled');
            } else {
              optionElement.classList.add('disabled');
            }
          });
        });
  
        const currentVariant = findVariantByOptions(productId, currentOptions);
        if (currentVariant) {
          const pdpBundlePicker = container.closest('[js-pdp-bundle-picker]');
          if (pdpBundlePicker) {
            const selectedBundleOption = pdpBundlePicker.getAttribute('data-selected-bundle-option');
            const containerIndex = container.getAttribute('js-bundle-variant-picker');
            
            // Try multiple ways to find the color option
            let selectedColorOption = container.querySelector('[js-option].color-option.selected'); // Original way
            
            if (!selectedColorOption) {
              // Fallback: find selected option in first wrapper (usually color)
              selectedColorOption = container.querySelector('[js-option-wrapper]:first-child [js-option].selected');
            }
            
            if (!selectedColorOption) {
              // Another fallback: find any selected option
              selectedColorOption = container.querySelector('[js-option].selected');
            }
            
            if (selectedColorOption) {
              const selectedColor = selectedColorOption.getAttribute('js-option');
              
              pdpBundlePicker.querySelectorAll(`[data-bundle-option="${selectedBundleOption}"] .image-wrapper img[data-index="${containerIndex}"]`).forEach(image => {
                if (image.getAttribute('data-color-value') == selectedColor) {
                  image.classList.add('active');
                } else {
                  image.classList.remove('active');
                }
              });
            }
          }
          
          container.setAttribute('data-variant-id', currentVariant.id);
          container.dispatchEvent(new CustomEvent('bundle:variant:change', {
            detail: {
              variant: currentVariant,
              product: product
            }
          }));
        }
  
      } catch (error) {
        console.error('Error parsing product JSON:', error);
      }
    };
  
    var changeVariant = (container, option) => {
      if (!container || !option) return;
      
      if (option.classList.contains('disabled')) {
        return;
      }
  
      const optionWrapper = option.closest('[js-option-wrapper]');
      if (!optionWrapper) return;
  
      optionWrapper.querySelectorAll('[js-option]').forEach(element => {
        element.classList.remove('selected');
      });
      option.classList.add('selected');
  
      const currentOptionLabel = optionWrapper.querySelector('[js-current-option]');
      if (currentOptionLabel) {
        currentOptionLabel.innerText = option.getAttribute('js-option');
      }
  
      updateOptionAvailability(container);
    };
  
    var initializeDefaultVariant = (container) => {
      const productJson = container.querySelector('script[data-product-json]');
      if (!productJson) return;
  
      try {
        const product = JSON.parse(productJson.textContent);
        
        // Get the container index to determine which variant to select
        const containerIndex = parseInt(container.getAttribute('js-bundle-variant-picker')) || 1;
        
        // Get all available variants
        const availableVariants = product.variants.filter(variant => variant.available);
        
        if (availableVariants.length === 0) return;
        
        // Find color option (assuming it's typically option1, but let's be flexible)
        let colorOptionIndex = 1; // Default to option1
        const colorLabels = ['color', 'colour', 'farbe', 'couleur']; // Add more languages as needed
        
        product.options.forEach((option, index) => {
          if (colorLabels.includes(option.toLowerCase())) {
            colorOptionIndex = index + 1;
          }
        });
        
        // Get unique color values from available variants
        const availableColors = [...new Set(availableVariants.map(variant => 
          variant[`option${colorOptionIndex}`]
        ))].filter(color => color); // Filter out null/undefined values
        
        let selectedVariant;
        
        // Try to select a different color for each container
        if (availableColors.length >= containerIndex) {
          // If we have enough colors, select the nth color for the nth container
          const targetColor = availableColors[containerIndex - 1];
          selectedVariant = availableVariants.find(variant => 
            variant[`option${colorOptionIndex}`] === targetColor
          );
        } else {
          // If not enough colors, cycle through available colors
          const colorIndex = (containerIndex - 1) % availableColors.length;
          const targetColor = availableColors[colorIndex];
          selectedVariant = availableVariants.find(variant => 
            variant[`option${colorOptionIndex}`] === targetColor
          );
        }
        
        // Fallback to first available variant if no color-based selection worked
        if (!selectedVariant) {
          selectedVariant = availableVariants[0];
        }
        
        // Set the selected variant options in the UI
        container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, index) => {
          const optionValue = selectedVariant[`option${index + 1}`];
          const optionElement = wrapper.querySelector(`[js-option][js-option="${optionValue}"]`);
          
          if (optionElement) {
            // Remove selected class from all options in this wrapper
            wrapper.querySelectorAll('[js-option]').forEach(el => el.classList.remove('selected'));
            // Add selected class to the target option
            optionElement.classList.add('selected');
            
            // Update the current option label if it exists
            const currentOptionLabel = wrapper.querySelector('[js-current-option]');
            if (currentOptionLabel) {
              currentOptionLabel.innerText = optionValue;
            }
          }
        });
        
        container.setAttribute('data-variant-id', selectedVariant.id);
  
        // Force update option availability to ensure UI is consistent
        updateOptionAvailability(container);
        
        // Trigger bundle variant change event for any listeners
        container.dispatchEvent(new CustomEvent('bundle:variant:change', {
          detail: {
            variant: selectedVariant,
            product: product
          }
        }));
  
      } catch (error) {
        console.error('Error initializing default variant:', error);
      }
    };
  
    var initEachContainer = (container, nextContainers = []) => {
      if (!container) return;
  
      initializeDefaultVariant(container);
  
      container.querySelectorAll('[js-option-wrapper] [js-option]').forEach(element => {
        element.addEventListener('click', () => {
          changeVariant(container, element);
          nextContainers.forEach(nextContainer => {
            changeVariant(nextContainer, nextContainer.querySelector(`[js-option-wrapper="${element.closest('[js-option-wrapper]').getAttribute('js-option-wrapper')}"] [js-option="${element.getAttribute('js-option')}"]`));
          });
        });
      });
    };
  
    var getNextBundleVariantPickers = (currentContainer) => {
      const nextContainers = [];
      let nextElement = currentContainer.nextElementSibling;
      
      while (nextElement) {
          if (nextElement.matches('[js-bundle-variant-picker]')) {
              nextContainers.push(nextElement);
          }
          nextElement = nextElement.nextElementSibling;
      }
      
      return nextContainers;
    }
  
    var initialize = () => {
      document.querySelectorAll('[js-bundle-variant-picker]').forEach(container => {
        initEachContainer(container, getNextBundleVariantPickers(container));
      });
    };
  
    return {
      init: initialize,
      getCurrentOptions: getCurrentOptions,
      findVariantByOptions: findVariantByOptions,
      initializeDefaultVariant: initializeDefaultVariant
    };
  })();


  var PDPSizePickerApp = (() => {
    var open = (container) => {
      if (!container || !container.querySelector('[js-chart-modal]')) return;
      container.querySelector('[js-chart-modal]').classList.add('open');
    }
    var close = (container) => {
      if (!container || !container.querySelector('[js-chart-modal]')) return;
      container.querySelector('[js-chart-modal]').classList.remove('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-container] [js-chart-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-container]'));
        });
      });
      document.querySelectorAll('[js-container] [js-chart-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          close(element.closest('[js-container]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var CustomSelectElementApp = (() => {
    let observer;
    
    var attachSelectListener = (selectElement) => {
      if (selectElement.hasAttribute('data-listener-attached')) {
        return;
      }
      
      selectElement.addEventListener('change', () => {
        const container = selectElement.closest('[js-custom-select-element]');
        const selectedValue = container.querySelector('[js-selected-value]');
        if (selectedValue) {
          selectedValue.innerHTML = selectElement.value;
        }
      });
      
      selectElement.setAttribute('data-listener-attached', 'true');
    };
    
    var processSelectElements = (containerElement = document) => {
      containerElement.querySelectorAll('[js-custom-select-element] select').forEach(selectElement => {
        attachSelectListener(selectElement);
      });
    };
    
    var initializeMutationObserver = () => {
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            
            if (node.hasAttribute && node.hasAttribute('js-custom-select-element')) {
              processSelectElements(node);
            }
            
            if (node.querySelectorAll) {
              processSelectElements(node);
            }
          });
        });
      });
        
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };
    
    var initialize = () => {
      processSelectElements();
      
      initializeMutationObserver();
    };
    
    var destroy = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
        
      document.querySelectorAll('[js-custom-select-element] select[data-listener-attached]').forEach(select => {
        select.removeAttribute('data-listener-attached');
      });
    };
    
    return {
      init: initialize,
      destroy: destroy,
      processNew: processSelectElements
    };
  })();


  var InfoDisplayAfterATCApp = (() => {
    var hide = (element) => {
      if (!element) return;
      element.classList.add('d-none');
    }
    var show = (element) => {
      if (!element) return;
      element.classList.remove('d-none');
    }
    var initialize = () => {
      document.querySelectorAll('[js-display-info-after-atc]').forEach(element => {
        hide(element);
      });
      document.addEventListener('cart:change', (e) => {
        const items = e.detail.cart.items;
        if (document.querySelector('[data-block-type=buy-buttons] input[name=product-id]')) {
          const currentProductId = document.querySelector('[data-block-type=buy-buttons] input[name=product-id]').value;
          let currentItemCount = 0;
          Array.from(items).forEach(item => {
            if (String(item.product_id) === String(currentProductId)) {
              currentItemCount+=item.quantity;
            }
          });
          document.querySelectorAll('[js-display-info-after-atc]').forEach(element => {
            if (element.getAttribute('js-display-info-after-atc') === String(currentItemCount)) {
              show(element);
            } else {
              hide(element);
            }
          });
        }

      });
    }
    return {
      init: initialize
    }
  })();


  var FreeShippingSupportApp = (() => {
    var updateShippingAttribute = async (is_free_shipping) => {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              "__free_shipping": `${is_free_shipping}`
            }
          })
        });
        
        const cart = await response.json();
        console.log('Cart updated:', cart);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
    var run = (items=null) => {
      let free_shipping_product_flag = false;
      if (items) {
        Array.from(items).forEach(item => {
          if (!item.properties['_non_free_shipping_product']) {
            free_shipping_product_flag = true;
          }
        });
      }
      if (
        (
          document.body.hasAttribute('shipping-threshold-ab-test-a') &&
          document.querySelector('.cart-drawer__shipping-threshold-v1.free-shipping')
        ) ||
        (
          document.body.hasAttribute('shipping-threshold-ab-test-b') &&
          document.querySelector('.cart-drawer__shipping-threshold-v2.free-shipping')
        ) || free_shipping_product_flag
      ) {
        updateShippingAttribute(true);
      } else {
        updateShippingAttribute(false);
      }
    }
    var initialize = () => {
      run();
      document.addEventListener('cart:change', (e) => {
        setTimeout(() => {
          run(e.detail.cart.items);
        }, 2000);
      });
    }
    return {
      init: initialize
    }
  })();


  var ProductStockMessageApp = (() => {
    const STORAGE_KEY = '[BD] Product stock random percent';
    
    var saveDataToLocalStorage = (data, product_id) => {
      let percent_storage_data_json = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!percent_storage_data_json) percent_storage_data_json = {};

      percent_storage_data_json[product_id] = {};
      percent_storage_data_json[product_id]['time'] = Date().toString();
      percent_storage_data_json[product_id]['data'] = data;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(percent_storage_data_json));
    }
    
    var animatePercent = (container, targetPercent) => {
      const duration = 3000; // 2 seconds
      const startPercent = 100;
      const startTime = performance.now();
      
      const percentMessageElement = container.querySelector('[js-percent-message]');
      const template = percentMessageElement?.getAttribute('data-template');
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // 0 to 1
        
        // Easing function (ease-out) for smoother animation
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        
        // Calculate current percent value
        const currentPercent = Math.round(startPercent - (startPercent - targetPercent) * easeProgress);
        
        // Update CSS variable
        container.style.setProperty('--percent', `${currentPercent}%`);
        
        // Update message element
        if (percentMessageElement && template) {
          percentMessageElement.innerHTML = template.replace('((value))', `<span>${currentPercent}%</span>`);
        }
        
        // Continue animation if not finished
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      
      requestAnimationFrame(animate);
    }
    
    var initEachContainer = (container) => {
      if (!container) return;
      
      const min_random_percent = isNaN(parseInt(container.getAttribute('data-min-percent-value'))) ? 0 : parseInt(container.getAttribute('data-min-percent-value'));
      const max_random_percent = isNaN(parseInt(container.getAttribute('data-max-percent-value'))) ? 100 : parseInt(container.getAttribute('data-max-percent-value'));
      let percent_value = HelperApp.getRandomInt(min_random_percent, max_random_percent);

      const product_id = container.getAttribute('data-product-id');
      let percent_storage_data_json = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!percent_storage_data_json || !percent_storage_data_json[product_id] || !percent_storage_data_json[product_id]['time'] || !percent_storage_data_json[product_id]['data']) {
        saveDataToLocalStorage(percent_value, product_id);
      } else {
        const saved_time = new Date(percent_storage_data_json[product_id]['time']);
        const now = new Date();
        if (
          saved_time.getFullYear() === now.getFullYear() &&
          saved_time.getMonth() === now.getMonth() &&
          saved_time.getDate() === now.getDate() && 
          percent_storage_data_json[product_id]['data'] >= min_random_percent &&
          percent_storage_data_json[product_id]['data'] <= max_random_percent
        ) {
          percent_value = percent_storage_data_json[product_id]['data'];
        } else {
          saveDataToLocalStorage(percent_value, product_id);
        }
      }

      // Start animation from 100% to the target percent
      animatePercent(container, percent_value);
    }
    
    var initialize = () => {
      const containers = document.querySelectorAll('[js-stock-message-wrapper]');
      
      if (containers.length === 0) return;
      
      // Create Intersection Observer
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Element is in viewport, initialize it
            initEachContainer(entry.target);
            // Stop observing this element after initialization
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '50px'
      });
      
      // Observe each container
      containers.forEach(container => {
        observer.observe(container);
      });
    }
    
    return {
      init: initialize
    }
  })();


  var CartLineItemKeepSavingApp = (() => {
    var openRemoveNotification = (lineItem, remove_button=false) => {
      if (!lineItem || !document.querySelector('[js-cart-line-item-remove-notification-template]')) return;
      document.querySelectorAll('.cart-drawer__line-items [js-cart-line-item-remove-notification]').forEach(element => {
        closeNotification(element);
      });
      if (document.body.hasAttribute('cart-line-item-keep-saving-logic-ab-test-1') && lineItem.hasAttribute('data-discounted-price') && !lineItem.querySelector('[confirm-waiting]')) {
        const remove_notification_wrapper_html = String(document.querySelector('[js-cart-line-item-remove-notification-template]').innerHTML).replace('((value))', lineItem.getAttribute('data-discounted-price')).replace('((line_key))', lineItem.getAttribute('data-line-key'));
        lineItem.outerHTML += remove_notification_wrapper_html;
        const addedNotificationWrapper = document.querySelector('line-item+[js-cart-line-item-remove-notification]');
        if (addedNotificationWrapper) {
          if (remove_button) {
            addedNotificationWrapper.setAttribute('remove', true);
          } else {
            addedNotificationWrapper.removeAttribute('remove');
          }
        }
      }
      if (document.body.hasAttribute('cart-line-item-keep-saving-logic-ab-test-2') && lineItem.hasAttribute('data-discounted-price') && !lineItem.querySelector('[confirm-waiting]')) {
        const remove_notification_wrapper_html = String(document.querySelector('[js-cart-line-item-remove-notification-template]').innerHTML).replace('((value))', lineItem.getAttribute('data-discounted-price')).replace('((line_key))', lineItem.getAttribute('data-line-key'));
        lineItem.outerHTML += remove_notification_wrapper_html;
        const addedNotificationWrapper = document.querySelector('line-item+[js-cart-line-item-remove-notification]');
        if (addedNotificationWrapper) {
          setTimeout(() => {
            addedNotificationWrapper.classList.add('open');
            if (remove_button) {
              addedNotificationWrapper.setAttribute('remove', true);
            } else {
              addedNotificationWrapper.removeAttribute('remove');
            }
          });
        }
      }
    }
    var closeNotification = (notificationWrapper) => {
      if (!notificationWrapper) return;
      if (document.body.hasAttribute('cart-line-item-keep-saving-logic-ab-test-1')) {
        notificationWrapper.style.maxHeight = '0px';
        setTimeout(() => {
          notificationWrapper.remove();
        }, 300);
      }
      if (document.body.hasAttribute('cart-line-item-keep-saving-logic-ab-test-2')) {
        notificationWrapper.classList.remove('open');
        setTimeout(() => {
          notificationWrapper.remove();
        }, 300);
      }
    }
    var confirmRemove = (notificationWrapper) => {
      if (!notificationWrapper) return;
      const lineItemQuantity = document.querySelector(`cart-drawer line-item[data-line-key="${notificationWrapper.getAttribute('data-line-key')}"] line-item-quantity`);
      if (!lineItemQuantity) return;
      lineItemQuantity.setAttribute('confirm-waiting', true);
      let button = lineItemQuantity.querySelector('[js-quantity-decrease]');
      if (notificationWrapper.hasAttribute('remove')) {
        button = lineItemQuantity.querySelector('.line-item__remove');
      }
      if (!button) return;
      button.click();
      closeNotification(notificationWrapper);
    }
    var initialize = () => {
      document.addEventListener('click', (e) => {
        if (e.target.closest('.cart-drawer line-item-quantity .line-item__remove')) {
          openRemoveNotification(e.target.closest('line-item'), true);
        }
        if (e.target.closest('.cart-drawer line-item-quantity [js-quantity-decrease]')) {
          openRemoveNotification(e.target.closest('line-item'));
        }
        if (e.target.closest('[js-cart-line-item-remove-notification] [js-close]')) {
          closeNotification(e.target.closest('[js-cart-line-item-remove-notification]'));
        }
        if (e.target.closest('[js-cart-line-item-remove-notification] [js-confirm]')) {
          confirmRemove(e.target.closest('[js-cart-line-item-remove-notification]'));
        }
      });
      function handleNotificationAppear(element) {
        console.log('Cart remove notification appeared:', element);
        element.style.maxHeight = element.scrollHeight + 'px';
      }

      function checkExistingElements() {
        const existingElements = document.querySelectorAll('[js-cart-line-item-remove-notification]');
        existingElements.forEach(element => {
          handleNotificationAppear(element);
        });
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            // Check if the added node itself has the attribute
            if (node.nodeType === 1) { // Element node
              if (node.hasAttribute && node.hasAttribute('js-cart-line-item-remove-notification')) {
                handleNotificationAppear(node);
              }
              
              // Also check children of the added node
              const childElements = node.querySelectorAll?.('[js-cart-line-item-remove-notification]');
              childElements?.forEach(element => {
                handleNotificationAppear(element);
              });
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Check for elements that already exist
      checkExistingElements();
    }
    return {
      init: initialize
    }
  })();


  var ProductReviewRatingReplaceApp = (() => {
    const svgReplacement = `
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M6.5 0L8.30775 4.57002L13 4.96556L9.425 8.18552L10.5173 13L6.5 10.42L2.48278 13L3.575 8.18552L0 4.96556L4.69226 4.57002L6.5 0Z" fill="#7B5EA7"/>
      </svg>
    `;
    
    const replaceStars = () => {
      document.querySelectorAll('.lai-wrap-block-star .lai-group-star:not([data-star-replaced])').forEach(element => {
        element.setAttribute('data-star-replaced', 'true');
        element.outerHTML = svgReplacement;
      });
    };
    
    const observeDOM = () => {
      const observer = new MutationObserver((mutations) => {
        let shouldReplace = false;
        
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                if (node.matches && node.matches('.lai-wrap-block-star .lai-group-star')) {
                  shouldReplace = true;
                } else if (node.querySelector) {
                  if (node.querySelector('.lai-wrap-block-star .lai-group-star')) {
                    shouldReplace = true;
                  }
                }
              }
            });
          }
        });
        
        if (shouldReplace) {
          replaceStars();
        }
      });
        
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };
    
    const initialize = () => {
      replaceStars();
      observeDOM();
    };
    
    return {
      init: initialize
    };
  })();


  var ProductCompareBlockApp = (() => {
    var goToPDPAtcButton = () => {
      const buyButtonBlock = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
      if (!buyButtonBlock) return;
      window.scrollTo(0, window.scrollY + buyButtonBlock.getBoundingClientRect().bottom - window.innerHeight + 40);
    }
    var initialize = () => {
      document.querySelectorAll('[js-cta-to-atc]').forEach(element => {
        element.addEventListener('click', () => {
          goToPDPAtcButton();
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var PDPSizeCalculatorApp = (() => {
    const BAND_SIZE_LIST = ['32', '34', '36', '38', '40', '42', '44', '46'];
    const CUP_SIZE_LIST = ['B', 'C', 'D', 'DD(E)', 'DDD'];
    const SIZE_TABLE = {
      '32': {
        'D': 'S',
        'DD(E)': 'S',
        'DDD': 'S',
      },
      '34': {
        'B': 'S',
        'C': 'S',
        'D': 'M',
        'DD(E)': 'M',
        'DDD': 'M',
      },
      '36': {
        'B': 'M',
        'C': 'M',
        'D': 'L',
        'DD(E)': 'L',
        'DDD': 'L',
      },
      '38': {
        'B': 'L',
        'C': 'L',
        'D': 'XL',
        'DD(E)': 'XL',
        'DDD': 'XL',
      },
      '40': {
        'B': 'XL',
        'C': 'XL',
        'D': 'XL',
        'DD(E)': '2XL',
        'DDD': '2XL',
      },
      '42': {
        'B': '2XL',
        'C': '2XL',
        'D': '2XL',
        'DD(E)': '3XL',
        'DDD': '3XL',
      },
      '44': {
        'B': '2XL',
        'C': '3XL',
        'D': '3XL',
        'DD(E)': '3XL',
        'DDD': '4XL',
      },
      '46': {
        'B': '3XL',
        'C': '4XL',
        'D': '4XL',
        'DD(E)': '4XL',
      }
    };
    let sizeCalculatorWrapper = null;
    var waitForElement = (selector, callback, timeout = 10000) => {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          callback(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      if (timeout) {
        setTimeout(() => {
          observer.disconnect();
          console.warn(`Element ${selector} not found within ${timeout}ms`);
        }, timeout);
      }
    }

    var open = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.add('open');
    }

    var close = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.remove('open');
      setTimeout(() => {
        modal.querySelectorAll('[data-step]').forEach(element => {
          element.classList.remove('active');
          if (element.getAttribute('data-step') === '1') {
            element.classList.add('active');
          }
        });
        modal.querySelectorAll('[data-value]').forEach(element => {
          element.classList.remove('active');
        });
        closeAccordion(container.querySelector('[js-accordion]'));
        if (container.querySelector('[js-accordion] [js-header]')) {
          container.querySelector('[js-accordion] [js-header]').classList.remove('result');
        }
      }, 1000);
    }

    var applySelectedSize = (container) => {
      if (!container) return;
      const variantPicker = document.querySelector('kaching-bundle');
      if (variantPicker) {
        if (container.getAttribute('data-size-type') === 'two_size') {
          container.querySelectorAll('[data-option-name]').forEach(optionValueListWrapper => {
            const selectedElement = optionValueListWrapper.querySelector('.active[data-value]');
            if (selectedElement) {
              variantPicker.querySelectorAll(`.kaching-bundles__bar .kaching-bundles__bar-variant-selector-wrapper:not(.kaching-bundles__bar-variant-selector-wrapper+.kaching-bundles__bar-variant-selector-wrapper) .kaching-bundles__bar-variant-select[data-name="${optionValueListWrapper.getAttribute('data-option-name')}"]`).forEach((select) => {
                select.value = selectedElement.getAttribute('data-value');
                setTimeout(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                });
              });
            }
          });
        } else if (container.getAttribute('data-size-type') === 'one_size') {
          const selected_size = (container.querySelector('[data-selected-size-text] [js-value]')) ? (container.querySelector('[data-selected-size-text] [js-value]').innerText) : '';
          if (selected_size !== '' && selected_size !== 'N/A') {
            variantPicker.querySelectorAll(`.kaching-bundles__bar .kaching-bundles__bar-variant-selector-wrapper:not(.kaching-bundles__bar-variant-selector-wrapper+.kaching-bundles__bar-variant-selector-wrapper) .kaching-bundles__bar-variant-select[data-name="Size"]`).forEach((select) => {
              select.value = selected_size;
              setTimeout(() => {
                select.dispatchEvent(new Event('change', { bubbles: true }));
              });
            });
          }
        }
        variantPicker.querySelectorAll('.kaching-bundles__block .kaching-bundle-info--wrapper').forEach(bundleInfoWrapper => {
          let selected_size = '';
          const selectedOptionText = bundleInfoWrapper.querySelector('[js-selected-option-text]');
          if (selectedOptionText) {
            if (container.getAttribute('data-size-type') === 'two_size') {
              container.querySelectorAll('[data-selected-size-text] .two-size-text span').forEach(span => {
                selected_size += span.innerText;
              });
            } else if (container.getAttribute('data-size-type') === 'one_size') {
              const selectedTextWrapper = container.querySelector('[data-selected-size-text] .one-size-text');
              if (selectedTextWrapper) {
                selected_size = selectedTextWrapper.innerText;
              }
            }
            selectedOptionText.innerHTML = selected_size;
          }

          var randomValue = HelperApp.getRandomInt(96, 98);
          const infoText = bundleInfoWrapper.querySelector('[js-kaching-bundle-info-text]');
          if (infoText) {
            infoText.innerHTML = infoText.getAttribute('js-kaching-bundle-info-text').replace('((random_value))', String(randomValue)).replace('((selected_size))', selected_size);
          }

          bundleInfoWrapper.classList.remove('d-none');
        });
      }
      close(container);
    }

    var back = (container) => {
      if (!container) return;
      let current_step = 0;
      let next_step = 0;
      if (container.querySelector('[data-step].active')) {
        current_step = parseInt(container.querySelector('[data-step].active').getAttribute('data-step'));
        next_step = current_step - 1;
      }
      if (next_step > 0) {
        container.querySelectorAll('[data-step]').forEach(stepElement => {
          stepElement.classList.remove('active');
          if (String(stepElement.getAttribute('data-step')) === String(next_step)) {
            stepElement.classList.add('active');
            stepElement.querySelectorAll('[data-value]').forEach(element => {
              element.classList.remove('active');
            });
          }
        });
      }
    }

    var selectSize = (container, selectedElement) => {
      if (!container || !selectedElement) return;
      const optionValueListWrapper = selectedElement.closest('[data-option-name]');
      if (!optionValueListWrapper) return;
      optionValueListWrapper.querySelectorAll('[data-value]').forEach(element => {
        element.classList.remove('active');
      });
      selectedElement.classList.add('active');
      let current_step = 0;
      let next_step = 0;
      if (container.querySelector('[data-step].active')) {
        current_step = parseInt(container.querySelector('[data-step].active').getAttribute('data-step'));
        next_step = current_step + 1;
      }
      setTimeout(() => {
        if (next_step > 0) {
          container.querySelectorAll('[data-step]').forEach(stepElement => {
            stepElement.classList.remove('active');
            if (String(stepElement.getAttribute('data-step')) === String(next_step)) {
              stepElement.classList.add('active');
            }
          });
          const selectedTextWrapper = container.querySelector('[data-selected-size-text]');
          if (selectedTextWrapper) {
            if (container.getAttribute('data-size-type') === 'two_size' && selectedTextWrapper.querySelector(`[js-value-${current_step}]`)) {
              selectedTextWrapper.querySelector(`[js-value-${current_step}]`).innerHTML = selectedElement.getAttribute('data-value');
            } else if (container.getAttribute('data-size-type') === 'one_size' && selectedTextWrapper.querySelector('[js-value]')) {
              let value = SIZE_TABLE;
              container.querySelectorAll('[data-value].active').forEach(element => {
                value = value[element.getAttribute('data-value')];
              });
              if (!value) value = 'N/A';
              selectedTextWrapper.querySelector('[js-value]').innerHTML = value;
            }
          }
        }
      }, 500);
    }

    var isValidateValue = (element_1, element_2) => {
      if (!element_1 || !element_2) return false;

      element_1.classList.remove('invalid');
      element_2.classList.remove('invalid');

      const value_1 = parseInt(element_1.value);
      const value_2 = parseInt(element_2.value);

      if (value_1 >= value_2) {
        element_1.classList.add('invalid');
        element_2.classList.add('invalid');
        return false;
      }
      // return true;

      if ((value_1 < 28 || value_1 > 46) && (value_1 < 71 || value_1 > 117)) {
        element_1.classList.add('invalid');
        return false;
      }
      if ((value_2 < 28 || value_2 > 46) && (value_2 < 71 || value_2 > 117)) {
        element_2.classList.add('invalid');
        return false;
      }
      if (value_2 < value_1) {
        element_2.classList.add('invalid');
        return false;
      }
      if ((value_1 >= 28 && value_1 <= 46) && (value_2 >= 71 && value_2 <= 117)) {
        element_2.classList.add('invalid');
        return false;
      }
      return true;
    }

    var calculate = (element) => {
      if (!element) return;

      const underbust = element.querySelector('[js-underbust-input]');
      const fullbust = element.querySelector('[js-fullbust-input]');

      if (!isValidateValue(underbust, fullbust)) return;

      let underbust_value = parseInt(underbust.value);
      let fullbust_value = parseInt(fullbust.value);

      const even_add = 4;
      const odd_add = 5;

      if (underbust_value >= 71) {
        underbust_value = parseInt(underbust_value / 2.5);
        fullbust_value = parseInt(fullbust_value / 2.5);
      }

      const A_Z = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      let band_size = underbust_value;
      let cup_size = A_Z[fullbust_value - underbust_value];

      if (underbust_value % 2) {
        band_size += odd_add;
      } else {
        band_size += even_add;
      }

      if (band_size < 34) band_size = 34;
      if (band_size > 50) band_size = 50;

      const heading = element.querySelector('.helper-heading');
      if (!heading) return;
      heading.classList.add('result');
      const resultText = heading.querySelector('.result-text .text');
      if (!resultText || !heading.querySelector('[data-template]')) return;
      resultText.innerHTML = String(heading.querySelector('[data-template]').getAttribute('data-template')).replace('((value_1))', band_size).replace('((value_2))', cup_size);
      closeAccordion(element);
    }

    var openAccordion = (element) => {
      if (!element) return;
      element.classList.add('active');
      const elementBody = element.querySelector('[js-body]');
      if (!elementBody) return;
      elementBody.style.maxHeight = elementBody.scrollHeight + 'px';

      if (!element.hasAttribute('event-connected')) {
        const helperButton = element.querySelector('[js-helper-button]');
        if (!helperButton) return;
  
        const inputList = element.querySelectorAll('[js-core-size-input]');
        inputList.forEach(input => {
          input.addEventListener('input', () => {
            let flag = true;
            for (let i = 0; i < inputList.length; i++) {
              if (!inputList[i].value) flag = false;
            }
            if (flag) {
              helperButton.classList.add('active');
            } else {
              helperButton.classList.remove('active');
            }
          });
        });

        helperButton.addEventListener('click', () => {
          if (!helperButton.classList.contains('active')) return;
          calculate(element);
        });

        element.setAttribute('event-connected', true);
      }
    }

    var closeAccordion = (element) => {
      if (!element) return;
      element.classList.remove('active');
      element.querySelectorAll('[js-core-size-input]').forEach(input => {
        input.classList.remove('invalid');
        input.value = '';
      });
      const elementBody = element.querySelector('[js-body]');
      if (!elementBody) return;
      elementBody.style.maxHeight = 0 + 'px';
    }

    var initSizeList = () => {
      document.querySelectorAll('[js-pdp-size-calculator]').forEach(container => {
        container.querySelectorAll('[data-option-name="band_size"]').forEach(bandSizeWrapper => {
          if (!bandSizeWrapper.querySelector('*')) {
            bandSizeWrapper.innerHTML = `
              ${Array.from(BAND_SIZE_LIST).map(band_size => {
                return `<span data-value="${band_size}">${band_size}</span>`
              }).join('')}
            `;
            container.setAttribute('data-size-type', 'one_size');
          }
        });
        container.querySelectorAll('[data-option-name="cup_size"]').forEach(cupSizeWrapper => {
          if (!cupSizeWrapper.querySelector('*')) {
            cupSizeWrapper.innerHTML = `
              ${Array.from(CUP_SIZE_LIST).map(cup_size => {
                return `<span data-value="${cup_size}">${cup_size}</span>`
              }).join('')}
            `;
            container.setAttribute('data-size-type', 'one_size');
          }
        });
      });
    }

    var initialize = () => {
      initSizeList();
      let embed_flag = false;
      document.querySelectorAll('[js-pdp-size-calculator]').forEach(element => {
        if (element.hasAttribute('js-pdp-embed')) {
          embed_flag = true;
        }
        sizeCalculatorWrapper = element;
      });
      if (!sizeCalculatorWrapper) return;
      if (embed_flag) {
        waitForElement('kaching-bundle .kaching-bundles__block-title', (element) => {
          console.log('Element found:', element);
          element.outerHTML = element.outerHTML + sizeCalculatorWrapper.outerHTML;
        });
      }
      document.addEventListener('click', (e) => {
        if (e.target.closest('[js-pdp-size-calculator] [js-trigger]')) {
          open(e.target.closest('[js-pdp-size-calculator]'));
        }
        if (e.target.closest('[js-pdp-size-calculator] [js-modal] [js-close]')) {
          close(e.target.closest('[js-pdp-size-calculator]'));
        }
        if (e.target.closest('[js-pdp-size-calculator] [js-modal] [js-back]')) {
          back(e.target.closest('[js-pdp-size-calculator]'));
        }
        if (e.target.closest('[js-pdp-size-calculator] [js-accordion] [js-header]')) {
          if (e.target.closest('[js-pdp-size-calculator] [js-accordion]').classList.contains('active')) {
            closeAccordion(e.target.closest('[js-accordion]'));
          } else {
            openAccordion(e.target.closest('[js-accordion]'));
          }
        }
        if (e.target.closest('[js-pdp-size-calculator] [data-option-name] [data-value]')) {
          selectSize(e.target.closest('[js-pdp-size-calculator]'), e.target.closest('[js-pdp-size-calculator] [data-option-name] [data-value]'));
        }
        if (e.target.closest('[js-pdp-size-calculator] [js-apply-size]')) {
          applySelectedSize(e.target.closest('[js-pdp-size-calculator]'));
        }
      });
    }
    return {
      init: initialize
    }
  })();


  var DealCountdownApp = (() => {
    var pad2 = (n) => String(Math.max(0, n)).padStart(2, '0');

    var getEndMs = (timerRoot) => {
      var custom = timerRoot.getAttribute('data-end');
      if (custom && custom.trim()) {
        var parsed = Date.parse(custom.trim());
        if (!isNaN(parsed)) return parsed;
      }
      var eod = new Date();
      eod.setHours(23, 59, 59, 999);
      return eod.getTime();
    };

    var formatHours = (h) => (h > 99 ? String(h) : pad2(h));

    var updateTimer = (timerRoot) => {
      var endMs = getEndMs(timerRoot);
      var now = Date.now();
      var remaining = Math.max(0, endMs - now);
      var totalSec = Math.floor(remaining / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var boxes = timerRoot.querySelectorAll('[data-unit]');
      if (boxes.length < 3) return;
      var hv = boxes[0].querySelector('[data-timer-value]');
      var mv = boxes[1].querySelector('[data-timer-value]');
      var sv = boxes[2].querySelector('[data-timer-value]');
      if (hv) hv.textContent = formatHours(h);
      if (mv) mv.textContent = pad2(m);
      if (sv) sv.textContent = pad2(s);
    };

    var initScrollButtons = () => {
      document.querySelectorAll('[data-deal-countdown-scroll]').forEach((btn) => {
        btn.addEventListener('click', () => {
          var section = btn.closest('.shopify-section');
          if (!section) return;
          var next = section.nextElementSibling;
          if (next && typeof next.scrollIntoView === 'function') {
            next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
          }
        });
      });
    };

    var initialize = () => {
      document.querySelectorAll('[data-deal-countdown]').forEach((timerRoot) => {
        updateTimer(timerRoot);
        setInterval(() => updateTimer(timerRoot), 1000);
      });
      initScrollButtons();
    };

    return {
      init: initialize
    };
  })();


  var NumberListTimerApp = (() => {
    var minutesSinceMidnightGermany = () => {
      var now = new Date();
      var germany = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
      return germany.getHours() * 60 + germany.getMinutes();
    };
    var updateTimer = (el) => {
      var base = parseInt(el.getAttribute('data-timer-base') || 5000, 10);
      var value = base + minutesSinceMidnightGermany();
      var digits = String(value).split('');
      var cells = el.querySelectorAll('.number');
      for (var i = 0; i < cells.length; i++) {
        var span = cells[i].querySelector('span');
        if (span) span.textContent = digits[i] !== undefined ? digits[i] : '';
      }
      var numberCells = el.querySelectorAll('.number');
      for (var n = numberCells.length - 1; n >= digits.length; n--) {
        numberCells[n].remove();
      }
      var currentCount = el.querySelectorAll('.number').length;
      if (digits.length > currentCount) {
        var template = el.querySelector('.number');
        for (var j = currentCount; j < digits.length; j++) {
          var wrap = template ? template.cloneNode(true) : document.createElement('div');
          if (!template) wrap.className = 'number';
          var s = wrap.querySelector('span');
          if (s) s.textContent = digits[j]; else { var span = document.createElement('span'); span.textContent = digits[j]; wrap.appendChild(span); }
          el.appendChild(wrap);
        }
      }
    };
    var initialize = () => {
      document.querySelectorAll('.js-number-list-timer').forEach((list) => {
        updateTimer(list);
        setInterval(() => updateTimer(list), 60000);
      });
    };
    return {
      init: initialize
    };
  })();


  var BDModalApp = (() => {
    var open = (container) => {
      if (!container) return;
      container.classList.add('open');
    }
    var close = (container) => {
      if (!container) return;
      container.classList.remove('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-bd-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          open(document.querySelector(`[js-bd-modal="${element.getAttribute('js-bd-modal-trigger')}"]`));
        });
      });
      document.querySelectorAll('[js-bd-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          close(element.closest('[js-bd-modal]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDShowMoreApp = (() => {
    var showMore = (data_value) => {
      document.querySelectorAll(`[js-show-more-trigger="${data_value}"]`).forEach(element => {
        element.classList.add('triggered');
      });
      document.querySelectorAll(`[js-show-more-wrapper="${data_value}"]`).forEach(element => {
        element.classList.add('open');
        element.style.maxHeight = element.scrollHeight + 'px';
      });
    }
    var showLess = (data_value) => {
      document.querySelectorAll(`[js-show-less-trigger="${data_value}"]`).forEach(element => {
        element.classList.add('triggered');
      });
      document.querySelectorAll(`[js-show-more-wrapper="${data_value}"]`).forEach(element => {
        element.classList.remove('open');
        element.style.maxHeight = 0 + 'px';
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-show-more-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          showMore(element.getAttribute('js-show-more-trigger'));
        });
      });
      document.querySelectorAll('[js-show-less-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          showLess(element.getAttribute('js-show-less-trigger'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var FeaturedProductApp = (() => {
    var updateATCButton = (container) => {
      if (!container) return;
      const atcButtonSpan = container.querySelector('[data-block-type="buy-buttons"] button[type="submit"] [data-submit-text]');
      if (!atcButtonSpan) return;
      const selectedKachingBarPriceText = container.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
      if (!selectedKachingBarPriceText) return;
      atcButtonSpan.innerHTML = `${atcButtonSpan.getAttribute('data-submit-text')} - ${selectedKachingBarPriceText.innerText}`;
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        if (event.target.closest('.shopify-section--featured-product .kaching-bundles__bars')) {
          setTimeout(() => {
            updateATCButton(event.target.closest('.shopify-section--featured-product'));
          });
        }
      });
      function waitForBundleSection(callback) {
        const existingElement = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
        if (existingElement) {
          callback(existingElement);
          return;
        }
    
        // If DOM is not ready, wait for it
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            pollForElement(callback);
          });
        } else {
          pollForElement(callback);
        }
      }
    
      function pollForElement(callback) {
        const checkInterval = setInterval(() => {
          const element = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
          if (element) {
            clearInterval(checkInterval);
            callback(element);
          }
        }, 100); // Check every 100ms
    
        // Stop polling after 30 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          console.warn('Kaching bundle section not found within 30 seconds');
        }, 30000);
      }
    
      // Actually call the function with a callback
      waitForBundleSection((element) => {
        updateATCButton(element.closest('.shopify-section--featured-product'));
      });
    }
    return {
      init: initialize
    }
  })();


  var VideoWrapperApp = (() => {
    var play = (container) => {
      if (!container) return;
      const video = container.querySelector('video');
      if (!video) return;
      video.play();
      container.classList.add('playing');
    }
    var pause = (container) => {
      if (!container) return;
      const video = container.querySelector('video');
      if (!video) return;
      video.pause();
      container.classList.remove('playing');
    }
    var initialize = () => {
      document.querySelectorAll('[js-video-wrapper] [js-play]').forEach(element => {
        element.addEventListener('click', () => {
          play(element.closest('[js-video-wrapper]'));
        });
      });
      document.querySelectorAll('[js-video-wrapper] [js-pause]').forEach(element => {
        element.addEventListener('click', () => {
          pause(element.closest('[js-video-wrapper]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var App = (() => {
    var initialize = () => {
      PDPSizeFinderApp.init();
      ShippingProtectApp.init();
      CartTimerApp.init();
      CartDrawerUpsellProductApp.init();
      TabsContainerApp.init();
      PDPBundlePickerApp.init();
      BundleVariantPickerApp.init();
      PDPSizePickerApp.init();
      CustomSelectElementApp.init();
      InfoDisplayAfterATCApp.init();
      FreeShippingSupportApp.init();
      ProductStockMessageApp.init();
      CartLineItemKeepSavingApp.init();
      ProductReviewRatingReplaceApp.init();
      ProductCompareBlockApp.init();
      PDPSizeCalculatorApp.init();
      NumberListTimerApp.init();
      DealCountdownApp.init();
      BDModalApp.init();
      BDShowMoreApp.init();
      FeaturedProductApp.init();
      VideoWrapperApp.init();
      HelperApp.addNewBlockToKachingBundleSection();
      HelperApp.addSizeGuideToBundle();
      HelperApp.updateLineItemKeys();
      HelperApp.addPricePerUnitToKachingBundlePicker();

      document.addEventListener('cart:change', () => {
        HelperApp.updateLineItemKeys();
      });
      document.addEventListener('cart:refresh', () => {
        HelperApp.updateLineItemKeys();
      });
      
      // Initialize bundle variant pickers with different default colors immediately
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        const bundlePickers = document.querySelectorAll('[js-pdp-bundle-picker] [js-bundle-variant-picker]');
        if (bundlePickers.length > 0) {
          bundlePickers.forEach(container => {
            BundleVariantPickerApp.initializeDefaultVariant(container);
          });
        } else {
          // If no bundle pickers found immediately, try again after a short delay
          setTimeout(() => {
            document.querySelectorAll('[js-pdp-bundle-picker] [js-bundle-variant-picker]').forEach(container => {
              BundleVariantPickerApp.initializeDefaultVariant(container);
            });
          }, 200);
        }
      });
    }
    
    return {
      init: initialize
    }
  })();
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });


})();